import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  CHECK_FUNDING_TYPE_QUERY_KEY,
  CHECK_FUNDING_TYPE_URL
} from './queryConstants'

type FundingTypeCheck = {
  fundingTypeId: string
  residentId: string
}

type UseCheckFundingTypeReturn = {
  checkFundingTypeUsedInRota: (values: FundingTypeCheck) => Promise<any>
  isLoading: boolean
}

const useCheckFundingType = (): UseCheckFundingTypeReturn => {
  const createFunction = async (values: FundingTypeCheck) => {
    return postJSON({
      url: CHECK_FUNDING_TYPE_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    any,
    unknown,
    any,
    unknown
  >([CHECK_FUNDING_TYPE_QUERY_KEY], createFunction)

  const checkFundingTypeUsedInRota = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    checkFundingTypeUsedInRota,
    isLoading
  }
}

export default useCheckFundingType
